// API Endpoints
export const API_ENDPOINTS = {
  PROJECTS: 'portfolio_projects.json',
  SHARED_DATA: 'portfolio_shared_data.json'
};

// Languages
export const LANGUAGES = {
  PRIMARY: 'en',
  SECONDARY: 'pl'
};

// Language Icon IDs
export const LANGUAGE_ICON_IDS = {
  PRIMARY: 'primary-lang-icon',
  SECONDARY: 'secondary-lang-icon'
};
